import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useGymOptions } from './useGymOptions';

export const GymBreakdown = ({ data, prefix = 'gym-breakdown' }) => {
  const { language } = useLanguage();
  const { options } = useGymOptions();
  const it = language === 'IT';
  if (!data || (!data.total_minutes && !data.missing_duration_sessions)) return null;
  return <section className="min-w-0 border-t border-zinc-800 pt-4 space-y-3" data-testid={prefix}>
    <div className="flex flex-wrap justify-between gap-2 text-sm text-zinc-200">
      <h3 data-testid={`${prefix}-heading`}>{it ? 'Dettaglio GYM' : 'GYM breakdown'}</h3>
      <span data-testid={`${prefix}-total`}>{data.total_minutes} min</span>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {['objectives', 'body_regions'].map(dimension => <div className="min-w-0" key={dimension}>
        <h4 className="text-xs text-zinc-400 mb-2" data-testid={`${prefix}-${dimension}-heading`}>{dimension === 'objectives' ? (it ? 'Obiettivo' : 'Objective') : (it ? 'Regione corporea' : 'Body region')}</h4>
        {Object.entries(data[dimension] || {}).map(([code, value]) => <div key={code} className="flex justify-between gap-3 text-xs text-zinc-300 py-1" data-testid={`${prefix}-${dimension}-${code}`}>
          <span className="min-w-0 break-words">{options?.[dimension]?.[code]?.[language] || code}</span><span className="shrink-0">{value} min</span>
        </div>)}
        <div className="text-xs text-zinc-500 pt-1" data-testid={`${prefix}-${dimension}-unclassified`}>{it ? 'Non classificati' : 'Unclassified'}: {data.unclassified_minutes} min</div>
      </div>)}
    </div>
  </section>;
};